/**
 * ASSIST-01 — who is looking, read from the access token itself.
 *
 * The Vike property page has no AuthProvider, so the Assist card cannot use
 * `useAuth()` there. Both trees store the session token in localStorage, and
 * `getValidAccessToken()` returns it (refreshed when needed). Its `sub` claim
 * is the user id the server will see as `auth.uid()`; reading it here only
 * decides what to show and which cache entry to use. The server verifies the
 * token on every call.
 *
 * Imports nothing, so `tsx` tests can load it directly.
 */

function decodeBase64Url(segment: string): string | null {
  try {
    const base64 = segment.replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4);
    const binary = atob(padded);
    const bytes = Uint8Array.from(binary, (c) => c.charCodeAt(0));
    return new TextDecoder().decode(bytes);
  } catch {
    return null;
  }
}

/** The JWT's `sub`, or null for anything that is not a readable JWT. */
export function jwtSubject(token: string | null | undefined): string | null {
  if (!token) return null;
  const parts = token.split('.');
  if (parts.length !== 3) return null;
  const json = decodeBase64Url(parts[1]);
  if (!json) return null;
  try {
    const payload = JSON.parse(json) as { sub?: unknown };
    return typeof payload.sub === 'string' && payload.sub.length > 0 ? payload.sub : null;
  } catch {
    return null;
  }
}
